import React from "react";
import { Redirect } from "react-router-dom";

function Authorizer({ user, allowedOrgTypes, children }) {
  const isAuthorized = user && (!allowedOrgTypes || allowedOrgTypes.includes(user.orgType));
  return isAuthorized ? children : <Redirect to="/" />;
}

export default Authorizer;
